
const state = () => ({
  /**
   * This variable contains the current tenantUser ID.
   * @type Number
   */
  id: null,

  /**
   * This variable contains the current tenantUser data.
   * @type Object
   */
  data: {},

  /**
   * Determine the visibility of the BLOCK screen that disables the APP.
   * @type Boolean
   */
  screenBlocked: false,

  /**
   * Determine the visibility of the LOCK (or PIN) screen.
   * @type Boolean
   */
  screenLocked: undefined,

  /**
   * This variable gives the developer the oportunity to skip the LOCK screen.
   * @type Boolean
   */
  skipScreenLock: false,
})

const getters = {
  fullName: state => state.data.surname
    ? `${state.data.name} ${state.data.surname}`
    : state.data.name,
  _permission: (state, getters, rootState) => rootState.rummage.data.Permission
    ?.find(o => o.id == state.data.permission_id),
  role: (state, getters) => getters['_permission']?.name,
  can: (state, getters) => key => !! getters['_permission']?.[key],
}

const mutations = {
  block (state, v) {
    state.screenBlocked = v
  },
  unblock (state) {
    state.screenBlocked = false
  },
  skipScreenLock (state, v = true) {
    state.skipScreenLock = v
  },
  lock (state) {
    if (state.skipScreenLock) {
      return
    }
    state.id = null
    state.data = {}
    state.screenLocked = true
  },
  unlock (state, user = {}) {
    state.id = user.id
    state.data = user
    state.screenLocked = false
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
